export default __webpack_public_path__ + "static/media/icon-check-success.576c8804.svg";